import type { MACProductAction, MACProductState } from '../models';
import { ORDERABLE_ITEM_BY_ACCOUNT_ID } from '../actions/product';

export const initialState = {
  orderableItemByAccountId: {},
};

export default (
  state: MACProductState = initialState,
  action: MACProductAction,
): MACProductState => {
  if (action.type === ORDERABLE_ITEM_BY_ACCOUNT_ID) {
    return {
      ...state,
      orderableItemByAccountId: {
        ...state.orderableItemByAccountId,
        [action.accountId]: action.progress,
      },
    };
  }

  return state;
};
